/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import DateSelectorDays from '../../../pages/components/DateInputDays'
import { SelectGlobal } from '../../../pages/components/SelectGlobal'
import listLayoutStyles from '../../../pages/components/ListTableLayout/listTableLayout.module.css'
import styles from './orderServiceToolbar.module.css'

const STATUS_TABS = [
  { value: '', label: 'Total', qtdKey: 'total', color: 'dark' },
  { value: 'AGUARDANDO', label: 'Aguardando', qtdKey: 'aguardando', color: 'primary' },
  { value: 'AGENDADO', label: 'Agendado', qtdKey: 'agendado', color: 'info' },
  { value: 'EM ANDAMENTO', label: 'Em andamento', qtdKey: 'emAndamento', color: 'warning' },
  { value: 'FINALIZADO', label: 'Finalizado', qtdKey: 'finalizado', color: 'success' },
  { value: 'CANCELADO', label: 'Cancelado', qtdKey: 'cancelado', color: 'danger' },
]

type Props = {
  search: React.ReactNode
  filterStatus: string
  setFilterStatus: (value: string) => void
  orderOfServicesQtd: any
  filterDateInit: any
  setFilterDateInit: (value: any) => void
  filterDateEnd: any
  setFilterDateEnd: (value: any) => void
  filterCollaborator: any
  setFilterCollaborator: (value: any) => void
  filterClient: any
  setFilterClient: (value: any) => void
  collaborators: any[]
  clients: any[]
  showClientFilter?: boolean
  canCreate: boolean
  onCreate: () => void
}

export function OrderServiceToolbar({
  search,
  filterStatus,
  setFilterStatus,
  orderOfServicesQtd,
  filterDateInit,
  setFilterDateInit,
  filterDateEnd,
  setFilterDateEnd,
  filterCollaborator,
  setFilterCollaborator,
  filterClient,
  setFilterClient,
  collaborators,
  clients,
  showClientFilter = true,
  canCreate,
  onCreate,
}: Props) {
  const activeFiltersCount = [filterDateInit, filterDateEnd, filterCollaborator, filterClient]
    .filter((value) => value !== '' && value !== null && value !== undefined).length

  const clearFilters = () => {
    setFilterDateEnd('')
    setFilterDateInit('')
    setFilterStatus('')
    setFilterCollaborator('')
    setFilterClient('')
  }

  return (
    <div className={styles.toolbarWrap}>
      <div className={`${listLayoutStyles.listToolbar} ${listLayoutStyles.listToolbarPanel}`}>
        <div className={listLayoutStyles.listToolbarFilters}>
          <div className={styles.searchBox}>{search}</div>

          <div className='dropdown'>
            <button
              type='button'
              className='btn btn-lg btn-light btn-active-color-primary btn-sm dropdown-toggle position-relative'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              data-bs-auto-close='outside'
              title='Outros filtros'
            >
              <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3' />
              {activeFiltersCount > 0 && (
                <span className='position-absolute top-0 start-100 translate-middle badge badge-circle badge-primary'>
                  {activeFiltersCount}
                </span>
              )}
            </button>

            <div className={`dropdown-menu dropdown-menu-end p-4 ${listLayoutStyles.listFilterDropdownMenu} ${styles.filterMenu}`}>
              <label className='form-label fw-bold' style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}>Outros Filtros</label>
              <div className='separator my-2'></div>

              <div style={{marginTop: '0.5rem', marginBottom: '1rem', width: '100%'}}>
                <SelectGlobal
                  itens={Array.isArray(collaborators) ? collaborators : []}
                  buttonAll={true}
                  textSearch={'Buscar colaborador'}
                  textButtonInit={'Filtrar por COLABORADOR'}
                  labelKey='name'
                  valueKey='id'
                  typeIcon='icon'
                  linkIcon='bi bi-hammer text-gray-500'
                  value={filterCollaborator}
                  style={{width: '100%'}}
                  onChange={(value: string) => setFilterCollaborator(value)}
                />

                {showClientFilter && (
                  <SelectGlobal
                    itens={Array.isArray(clients) ? clients : []}
                    buttonAll={true}
                    textSearch={'Buscar cliente'}
                    textButtonInit={'Filtrar por CLIENTE'}
                    labelKey='nameResponsible'
                    valueKey='id'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/communication/com006.svg'
                    sizeIconSvg='2'
                    value={filterClient}
                    className='mt-1'
                    style={{width: '100%'}}
                    onChange={(value: string) => setFilterClient(value)}
                  />
                )}

                <div className='separator my-3'></div>
                <label className='form-label fw-bold mb-2'>Filtrar por PERÍODO</label>

                <div className={listLayoutStyles.listFilterDates}>
                  <div>
                    <label className='form-label fw-semibold fs-7 mb-1 text-gray-500'>Início a partir de</label>
                    <DateSelectorDays
                      selectedDate={filterDateInit !== '' ? new Date(filterDateInit) : new Date()}
                      setSelectedDate={(date: any) => setFilterDateInit(date.toString())}
                    />
                  </div>
                  <div>
                    <label className='form-label fw-semibold fs-7 mb-1 text-gray-500'>Encerramento até</label>
                    <DateSelectorDays
                      selectedDate={filterDateEnd !== '' ? new Date(filterDateEnd) : new Date()}
                      setSelectedDate={(date: any) => setFilterDateEnd(date.toString())}
                    />
                  </div>
                </div>
              </div>

              <div className='separator my-2'></div>

              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button
                  type='button'
                  className='btn btn-color-gray-600 btn-active-color-primary'
                  onClick={clearFilters}
                >
                  Limpar todos os filtros <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                </button>
              </div>
            </div>
          </div>
        </div>

        {canCreate && (
          <div className={`card-toolbar ${listLayoutStyles.listToolbarActions}`}>
            <a
              onClick={(event) => {
                event.preventDefault()
                onCreate()
              }}
              href='#'
              className='btn btn-sm btn-light-primary'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Nova O.S.
            </a>
          </div>
        )}
      </div>

      <div className={styles.statusTabs} role='tablist'>
        {STATUS_TABS.map((tab) => {
          const isActive = filterStatus === tab.value
          const count = orderOfServicesQtd && orderOfServicesQtd[tab.qtdKey] ? orderOfServicesQtd[tab.qtdKey] : 0
          return (
            <button
              key={tab.qtdKey}
              type='button'
              role='tab'
              aria-selected={isActive}
              className={`btn btn-sm ${styles.statusTab} ${
                isActive ? `btn-${tab.color} ${styles.statusTabActive}` : 'btn-color-gray-700 btn-active-light'
              }`}
              onClick={() => setFilterStatus(tab.value)}
            >
              <span>{tab.label}</span>
              <span className={`badge ${isActive ? styles.statusCountActive : `badge-light-${tab.color}`} ${styles.statusCount}`}>
                {count}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
